// Module
var code = "To read the next chapter you should go to a cafe or bar that you have visited in the past. You don't need to go in, just be near it.<br> Press ‘I’m there’ when you are. ";
// Exports
module.exports = code;